import React, { useState, useEffect } from 'react';
import InventoryForm from './InventoryForm';
import { Column, Row } from 'simple-flexbox';
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from '@material-ui/core';
import useTable from '../../../utilities/useTable';
import { ToastContainer } from 'react-toastify';
import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import Controls from '../../../controls/Controls';
import { Search } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import Popup from '../../../utilities/Popup';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Notification from '../../../utilities/Notification';
import ConfirmDialog from '../../../utilities/ConfirmDialog';
import AddInventoryForm from './AddInventoryForm';
import AddInventoryCount from './AddInventoryCount';
import InventoryCorrection from './InventoryCorrection';

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: '75%',
  },
  newButton: {
    position: 'absolute',
    right: '10px',
  },
}));

const headCells = [
  { id: 'locationAddress', label: 'Quantity Sold' },
  { id: 'locationName', label: 'Product Name' },
  { id: 'contactName', label: 'Gross Profit' },
  { id: 'contactName', label: 'Net Sales Value' },
  { id: 'contactName', label: 'Cost Sold' },
];

export function ProfitabilityReport({
  locations,
  roles,
  LoadProfitabilityReport,
  profitabilityReport,
}) {

  function VerifyRole() {
    var role = roles;
    if (role[0] == 'Inventory Manager' || role[0] == 'App Owner') {
      return true;
    }
  }
  
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  useEffect(() => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = yyyy + '/' + mm + '/' + dd;
    var payload = {
      startDate: today,
      endDate: today,
      locationId: locationId,
    };
    localStorage.setItem('startDate', payload.startDate);
    localStorage.setItem('endDate', payload.endDate);
    LoadProfitabilityReport(payload);
  }, []);
  const [openPopup, setOpenPopup] = useState(false);
  const [locationId, setLocationId] = useState(0);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [correctionOpenPopup, setCorrectionOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(profitabilityReport, headCells, filterFn);
  function handleInputChange(e) {
    const { name, value } = e.target;
    setLocationId(value);
    var payload = {
      startDate: localStorage.getItem('startDate'),
      endDate: localStorage.getItem('endDate'),
      locationId: locationId,
    };
    LoadProfitabilityReport(payload);
  }

  const handleInputStartDateChange = (e, v) => {
    if (e.target == null) {
      var dd = String(v.getDate()).padStart(2, '0');
      var mm = String(v.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = v.getFullYear();
      v = yyyy + '/' + mm + '/' + dd;
      localStorage.setItem('startDate', v);
    } else {
      localStorage.setItem('startDate', e.target.value);
    }

    var payload = {
      startDate: localStorage.getItem('startDate'),
      endDate: localStorage.getItem('endDate'),
      locationId: locationId,
    };
    LoadProfitabilityReport(payload);
  };
  const handleInputEndDateChange = (e, v) => {
    if (e.target == null) {
      var dd = String(v.getDate()).padStart(2, '0');
      var mm = String(v.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = v.getFullYear();
      v = yyyy + '/' + mm + '/' + dd;
      localStorage.setItem('endDate', v);
    } else {
      localStorage.setItem('endDate', e.target.value);
    }
    var payload = {
      startDate: localStorage.getItem('startDate'),
      endDate: localStorage.getItem('endDate'),
      locationId: locationId,
    };
    LoadProfitabilityReport(payload);
  };

  useEffect(() => {
    return () => { };
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === '') return items;
        else
          return items.filter((x) =>
            x.locationName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  return (
    <>
      <div
        className="container"

      >
        <div style={{marginTop:'-3rem'}}>
          <Column flexGrow={1}>
            <ToastContainer />
            <div
              className="mt-5"
              style={{ position: 'relative', left: '2.5rem', top: '-5rem' }}
            >
            </div>

            <Paper className={classes.pageContent}>
              <h4>
                {' '}
                <strong>Profitability Report</strong>
              </h4>
              <div
                className="container row p-0 m-0"
                style={{ width: '35rem', position: 'relative', left: '23rem' }}
              >
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  {' '}
                    <Controls.Select
                      name="locationId"
                      label="Locations"
                      placeholder="Locations"
                      onChange={handleInputChange}
                      options={locations}
                    />
                  <Controls.Input
                    name="date"
                    type="date"
                    value={localStorage.getItem("startDate") || ''}
                    onChange={handleInputStartDateChange}
                    style={{ marginRight: "1rem" }}
                  />{' '}
                  <Controls.Input
                    name="date"
                    type="date"
                    value={localStorage.getItem("endDate") || ''}
                    onChange={handleInputEndDateChange}
                  />{' '}
                </div>

                <div className="col"></div>
                <div className="col">
                  {VerifyRole() ? (
                    <Toolbar>

                    </Toolbar>
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.locationId}>
                      <TableCell>{item.quantitySold}</TableCell>
                      <TableCell>{item.productName}</TableCell>
                      <TableCell>{item.grossProfit}</TableCell>
                      <TableCell>{item.netSales}</TableCell>
                      <TableCell>{item.costSold}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>

            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    profitabilityReport: state.inventoryReducer.profitabilityReport,
    locations: state.locationReducer.locationDrop,
    roles: state.persistReucer.roles,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadProfitabilityReport(payload) {
    dispatch({ type: 'LOAD_PROFITABILITY_REPORT', payload });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfitabilityReport);
